import {
    PersonOutlineOutlined,
    ShoppingBagOutlined,
    TuneOutlined,
    AccountBalanceOutlined,
    ProductionQuantityLimits,
    LocalLibrary,
    Lightbulb,
} from "@mui/icons-material";
import type { AppContext, MpIframeContent, NavigationItem } from "../../../types";

const navigations = (context: AppContext, setMissingTransaction: (open?: unknown) => void): NavigationItem[] => {
    // The member portal always resolves adminConfig.mp_iframe_content before navigations() runs;
    // the original accessed it unguarded (context?.adminConfig.mp_iframe_content.X).
    const mp = context?.adminConfig?.mp_iframe_content as MpIframeContent;
    return [
        {
            name: context?.config.sectionHeaders?.account || `Cash Back Account`,
            icon: PersonOutlineOutlined,
            path: `/`,
        },
        {
            name: context?.config.sectionHeaders?.shopping || `Shopping History`,
            icon: ShoppingBagOutlined,
            path: `/shopping`,
        },
        {
            name: `Payout History`,
            icon: AccountBalanceOutlined,
            path: `/payouts`,
        },
        {
            name: `Missing AAA Dollars`,
            icon: ProductionQuantityLimits,
            path: mp.use_our_missing_trans_flow ? setMissingTransaction : mp.missing_aaa_dollars,
        },
        {
            name: `Preferences`,
            icon: TuneOutlined,
            path: `/preferences`,
        },
        mp.portal_learn_more_url
            ? {
                  name: `Learn More`,
                  icon: LocalLibrary,
                  path: mp.learn_more_is_iframe ? `/i/portal_learn_more` : mp.portal_learn_more_url,
              }
            : {},
        mp.portal_faqs_url
            ? {
                  name: `FAQs`,
                  icon: Lightbulb,
                  path: mp.faqs_is_iframe ? `/i/portal_faqs` : mp.portal_faqs_url,
              }
            : {},
    ];
};

export default navigations;
